.global-error {
  color: var(--old-red);
  font-size: 0.7em;
  text-align: left;
  margin: var(--spacing-small) 0;
  background-color: white;
  border-radius: 6px;
  padding: 8px;
}

.spacer {
  height: var(--spacing-base);
}
